import { type Image } from '@utils/cook/types'
import useSportEntitySubscriptions from '@hooks/useSportEntitySubscriptions'

import FollowMyTeamOverviewBanner from './FollowMyTeamOverviewBanner'
import FollowMyTeamOverviewWithSubscriptions from './FollowMyTeamOverviewWithSubscriptions'

interface FollowMyTeamOverviewAPIProps {
  backgroundImage: Image<'16_9'>
  image: Image<'free'>
  title: string
  onBannerClick: () => void
  onSettingsClick: () => void
  onAddTeamClick: () => void
}

const FollowMyTeamOverview = ({
  backgroundImage,
  image,
  title,
  onBannerClick,
  onSettingsClick,
  onAddTeamClick,
}: FollowMyTeamOverviewAPIProps) => {
  const {
    data: sportEntitySubscriptions,
    isSuccess: isEntitySubscriptionsSuccess,
  } = useSportEntitySubscriptions({
    entityType: 'competitor',
  })

  const hasSportEntitySubscriptions = sportEntitySubscriptions?.length

  return isEntitySubscriptionsSuccess ? (
    hasSportEntitySubscriptions ? (
      <FollowMyTeamOverviewWithSubscriptions
        sportEntitySubscriptions={sportEntitySubscriptions}
        onAddTeamClick={onAddTeamClick}
        onSettingsClick={onSettingsClick}
      />
    ) : (
      <FollowMyTeamOverviewBanner
        state="noPreferences"
        backgroundImage={backgroundImage}
        image={image}
        title={title}
        onClick={onBannerClick}
      />
    )
  ) : null
}

export default FollowMyTeamOverview
